// components/Layouts/Layout.js
import React from 'react';
import { Outlet } from "react-router-dom";

import '../../assets/css/layout.css'

const FullScreenLayout = () => {

    return (
        <div className='layoutWrapper'>
            <main className='appMain'>
                <Outlet />
            </main>
        </div>
    );
};

export default FullScreenLayout;
